import {
    CognitoIdentityProviderClient,
    CognitoIdentityProviderClientConfig,
    ResendConfirmationCodeCommand,
    ResendConfirmationCodeCommandOutput,
} from '@aws-sdk/client-cognito-identity-provider'
import getConfig from 'next/config'

async function resendVerification(
    data: Record<string, string>
): Promise<ResendConfirmationCodeCommandOutput> {
    const { COGNITO_CLIENT_ID: client_id, COGNITO_REGION: region } =
        getConfig().publicRuntimeConfig
    const { email } = data
    const config: CognitoIdentityProviderClientConfig = { region }
    const client = new CognitoIdentityProviderClient(config)

    const command = new ResendConfirmationCodeCommand({
        ClientId: client_id,
        Username: email,
    })

    return await client.send(command)
}

export default resendVerification
